/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DashboardAliases {
  CARD_0 = 'card-0',
  CARD_INFO_PLANO = 'card-info-plano',
  CARD_MSG = 'card-msg',
  DECK_MENSALIDADES = 'deck-mensalidades',
  FETCH_MENSALIDADES = 'fetch-mensalidades',
  FETCH_OPERADORA = 'fetch-operadora',
  FETCH_PLANO = 'fetch-plano',
  FIELD_ANS = 'field-ans',
  FIELD_CD_CGC = 'field-cdCgc',
  FIELD_DS_EMAIL_ANS = 'field-dsEmailAns',
  FIELD_NM_CONTATO_OPERADORA = 'field-nmContatoOperadora',
  FIELD_NOTA_FISCAL = 'field-nota-fiscal',
  FIELD_NR_TELEFONE_ANS = 'field-nrTelefoneAns',
  FIELD_NR_TELEFONE_OPERADORA = 'field-nrTelefoneOperadora',
  FIELD_NUCLEO = 'field-nucleo',
  FIELD_TITULO = 'field-titulo',
  FIELD_TOTAL = 'field-total',
  FIELD_VENCIMENTO = 'field-vencimento',
  FORM_INFO_ANS = 'form-info-ans',
  FORM_OPS_PHILIPS = 'form-ops-philips',
  FRAGMENT_MSG = 'fragment-msg',
  HPMS_CUSTOM_CARD_MENSALIDADES = 'hpms-custom-card-mensalidades',
  HPMS_DASHBOARD_SHOURTCUT_0 = 'hpms-dashboard-shourtcut-0',
  HPMS_DYNAMIC_CONTENT_SITUACAO = 'hpms-dynamic-content-situacao',
  IMAGE_DS_EMAIL_ANS = 'image-dsEmailAns',
  IMAGE_NR_TELEFONE_ANS = 'image-nrTelefoneAns',
  IMAGE_NR_TELEFONE_OPERADORA = 'image-nrTelefoneOperadora',
  LAYOUT_2 = 'layout-2',
  LAYOUT_DASHBOARD = 'layout-dashboard',
  LINK_ANS = 'link-ans',
  LINK_GUIA_MEDICO = 'link-guia-medico',
  LINK_NUCLEO = 'link-nucleo',
  LINK_ROL_PROCEDIMENTO = 'link-rol-procedimento',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_7 = 'panel-7',
  PANEL_CARD_MSG = 'panel-card-msg',
  PANEL_DASHBOARD = 'panel-dashboard',
  PANEL_GUIA_MEDICO = 'panel-guia-medico',
  PANEL_INFO = 'panel-info',
  PANEL_INFO_PLANO = 'panel-info-plano',
  PANEL_MENSALIDADE = 'panel-mensalidade',
  PANEL_MSG = 'panel-msg',
  PANEL_ROL_PROCEDIMENTO = 'panel-rol-procedimento',
  TEXT_0 = 'text-0',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_6 = 'text-6',
  TEXT_CD_CGC = 'text-cdCgc',
  TEXT_DS_EMAIL_ANS = 'text-dsEmailAns',
  TEXT_NM_CONTATO_OPERADORA = 'text-nmContatoOperadora',
  TEXT_NR_TELEFONE_ANS = 'text-nrTelefoneAns',
  TEXT_NR_TELEFONE_OPERADORA = 'text-nrTelefoneOperadora',
  TEXT_TITULO = 'text-titulo',
}
export { DashboardAliases };
